import { createEvent } from 'effector'
import { NavigateFunction } from 'react-router-dom'

export const setNavigate = createEvent<NavigateFunction>()
